import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../environments/environment';

@Injectable({
    providedIn: 'root'
})

export class ApiCommonService {

    baseUrl = environment.baseUrl;
    authUrl = environment.authority;
    tenantId: any;
    constructor(
        private http: HttpClient) {
        const userInforLS = localStorage.getItem('oidcCNF');
        if (userInforLS) {
            const userInfo = atob(userInforLS);
            this.tenantId = +JSON.parse(userInfo).tenantId;
        }
    }

    /**
     * Get all records (Dropdowns, Search, and etc...).
     * @param url  API url
     */
    get(url: string): Observable<any> {
        const fId = localStorage.getItem('oidcCNFFranchaiseId');
        let fIdQuery = '';
        if (this.tenantId == 0) {
            fIdQuery = url.split('?').length > 1 ? `&ImpTId=` + (+fId) : `?ImpTId=` + (+fId);
        }
        return this.http.get(`${this.baseUrl}${url}${fIdQuery}`).pipe(
            map((response: any) => {
                return response;
            }),
        );
    }

    /**
     * Get grid records with pagination and filters.
     * @param url API url
     * @param event Kendu grid event
     */
    getGridRecords(url: string, event: any, searchQuery?: string, statusQuery?: string, filterQuery?: string): Observable<any> {
        return this.get(
            `${url}?Results=${event.take}&Page=${event.skip}&OrderBy=${event.sort[0].field}&SortOrder=${event.sort[0].dir}${searchQuery}${statusQuery}${filterQuery}`,
        );
    }

    /**
     * Find record by id
     * @param url  API url
     * @param id Record id
     */
    getRecord(url: string, id: any): Observable<any> {
        return this.get(`${url}/${id}`);
    }

    /**
     * Create a new record.
     * @param url API url.
     * @param input Form data.
     */
    post(url: string, input: any): Observable<any> {
        const fId = localStorage.getItem('oidcCNFFranchaiseId');
        if (this.tenantId == 0) {
            input.impTId = +fId;
        }
        return this.http.post(`${this.baseUrl}${url}`, input).pipe(
            map((response: any) => {
                return response;
            }),
        );
    }

    /**
     * Update the specified record.
     * @param url API url.
     * @param input Form data.
     */
    update(url: string, input: any): Observable<any> {
        const fId = localStorage.getItem('oidcCNFFranchaiseId');
        if (this.tenantId == 0) {
            input.impTId = +fId;
        }
        return this.http.post(`${this.baseUrl}${url}`, input).pipe(
            map((response: any) => {
                return response;
            }),
        );
    }

    /**
     * Delete the specified record.
     * @param url API url.
     * @param deleteList Record Id(s)
     */
    delete(url: string, deleteList: any): Observable<any> {
        return this.http.post(`${this.baseUrl}${url}/delete`, { ids: deleteList }).pipe(
            map((response: any) => {
                return response;
            }),
        );
    }

    export(url: string, event: any, searchQuery?: string, statusQuery?: string, filterQuery?: string): Observable<any> {
        const fId = localStorage.getItem('oidcCNFFranchaiseId');
        let impTIdquery = '';
        if (this.tenantId == 0) {
            impTIdquery = `&ImpTId=` + (+fId);
        }
        return this.http
            .get(
                `${this.baseUrl}${url}?Results=${event.take}&Page=${event.skip}&OrderBy=${event.sort[0].field}&SortOrder=${event.sort[0].dir}${searchQuery}${statusQuery}${filterQuery}${impTIdquery}`,
                {
                    observe: 'response',
                    responseType: 'blob',
                },
            )
            .pipe(
                map((response: any) => {
                    return response;
                }),
            );
    }

    exportWithoutUrl(url: string): Observable<any> {
        const fId = localStorage.getItem('oidcCNFFranchaiseId');
        let impTIdquery = '';
        if (this.tenantId == 0) {
            impTIdquery = `&ImpTId=` + (+fId);
        }
        return this.http
            .get(
                `${this.baseUrl}${url}${impTIdquery}`,
                {
                    observe: 'response',
                    responseType: 'blob',
                },
            )
            .pipe(
                map((response: any) => {
                    return response;
                }),
            );
    }

    /**
     * Create a new record.
     * @param url API url.
     * @param input Form data.
     */
    put(url: string, input: any): Observable<any> {
        const fId = localStorage.getItem('oidcCNFFranchaiseId');
        if (this.tenantId == 0) {
            input.impTId = +fId;
        }
        return this.http.post(`${this.baseUrl}${url}`, input).pipe(
            map((response: any) => {
                return response;
            }),
        );
    }

    // Create new record for Identity Server
    postIdentityRecord(url: string, inputData: any): Observable<any> {
        const fId = localStorage.getItem('oidcCNFFranchaiseId');
        if (this.tenantId === 0) {
            inputData.impTId = +fId;
        }
        return this.http.post(`${this.authUrl}/api/${url}`, inputData).pipe(
            map((response: any) => {
                return response;
            }),
        );
    }


    fileDownload(url: string): Observable<any> {
        return this.http
            .get(
                `${this.baseUrl}${url}`,
                {
                    observe: 'response',
                    responseType: 'blob',
                },
            )
            .pipe(
                map((response: any) => {
                    return response;
                }),
            );
    }

    fileDownloadForPost(url: string, input: any): Observable<any> {
        return this.http.post(`${this.baseUrl}${url}`, input, {
            observe: 'response',
            responseType: 'blob',
        }).pipe(
            map((response: any) => {
                return response;
            }),
        );
    }

    // Get form Identity Server
    getIdentityRecords(url: string): Observable<any> {
        const fId = localStorage.getItem('oidcCNFFranchaiseId');
        let fIdQuery = '';
        if (this.tenantId === 0) {
            fIdQuery = url.split('?').length > 1 ? `&ImpTId=` + (+fId) : `?ImpTId=` + (+fId);
        }
        return this.http.get(this.authUrl + '/api/' + url + fIdQuery).pipe(
            map((response: any) => {
                return response;
            }),
        );
    }

    getIdentityGridRecords(url: string, event: any, searchQuery?: string, statusQuery?: string, filterQuery?: string): Observable<any> {
        return this.getIdentityRecords(
            `${url}?Results=${event.take}&Page=${event.skip}&OrderBy=${event.sort[0].field}&SortOrder=${event.sort[0].dir}${searchQuery}${statusQuery}${filterQuery}`,
        );
    }

    // Update new record for Identity Server
    putIdentityRecord(url: string, inputData: any): Observable<any> {
        const fId = localStorage.getItem('oidcCNFFranchaiseId');
        if (this.tenantId === 0) {
            inputData.impTId = +fId;
        }
        return this.http.post(this.authUrl + url, inputData).pipe(
            map((response: any) => {
                return response;
            }),
        );
    }

}